define [], () ->
  helper = (str, start, length) ->
    str.substr start, length

  helper



// WEBPACK FOOTER //
// ./app/scripts/Hasadna/oBudget/Misc/handlebarsHelpers/subStr.coffee